<template>
  <div id="loginpageadmin">
    <div class="login-header box-shadow">
        <div class="container-fluid d-flex justify-content-between align-items-center">
            <div class="brand-logo">
                <a href="#">
                    <!-- <img src="<?=base_url('assets/')?>vendors/images/deskapp-logo.svg" alt=""> -->
                    <div style="color:gray;">e-Billing Admin</div>
                </a>
            </div>
            <div class="login-menu">
                
            </div>
        </div>
    </div>
    <div class="login-wrap d-flex align-items-center flex-wrap justify-content-center">
        <div class="container">
            <div class="row align-items-center">
                <!-- <div class="col-md-6 col-lg-7">
                    <img src="<?=base_url('assets/')?>vendors/images/login-page-img.png" alt="">
                </div> -->
                <div class="col-md-12 col-lg-12">
                    <div class="login-box bg-white box-shadow border-radius-10">
                        <div class="login-title">
                            <h2 class="text-center">กำลังตรวจสอบสิทธิ์...</h2>
                        </div>
                        <div class="text-center p-5">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p class="mt-3">กรุณารอสักครู่ ระบบกำลังตรวจสอบ session จาก intranet</p>
                            <small class="text-muted">หากไม่มี session ระบบจะนำท่านไปยังหน้า login อัตโนมัติ</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- js -->
  </div>
</template>

<script>
// ไม่ต้อง import อะไรเพราะหน้านี้แค่แสดง loading
// ตัว redirect จริงๆ อยู่ที่ App.vue
export default {
    name:'Loginpageadmin',
	props:[
		'userDataProps',
		'accessData'
	],
	data() {
		return {
			url:this.getUrl(),
			baseurl:this.baseUrl()
		}
	},
	created() {
		
	},
	mounted() {
		// ไม่ต้องทำอะไร - ให้ App.vue จัดการ redirect แทน
		// หน้านี้จะแสดงชั่วคราวก่อนที่ App.vue จะ redirect ไป intranet
	},
    methods: {
		// ไม่มี methods เพราะ admin ต้อง login ที่ intranet เท่านั้น
    },
}
</script>


<style>

</style>